import { vaultFilesApi } from "@api";
import { queriesVaultFiles } from "@query";

import { useWSMutation } from "../../query/helpers";
import { downloadFileFromBuffer } from "../../utils/files";

export type DownloadVaultFileParams = {
  fileId: string;
};

/**
 * The v3 replacement for a v1 member-files download: the name/type and the
 * bytes are two separate vault reads. The metadata read is cache-first, and the
 * content read is typed `void` by the SDK (the endpoint answers a redirect), so
 * the bytes come off the raw response instead of a typed body.
 *
 * Not a registry entry — the registry is 1:1 with the SDK, and this pairs two
 * SDK calls around a browser download.
 */
export const useMutationDownloadVaultFile = () =>
  useWSMutation<void, unknown, DownloadVaultFileParams>(async ({ fileId }) => {
    const vaultFile = await queriesVaultFiles.getVaultFile.fetchQueryData({
      fileId
    });
    const response = await vaultFilesApi.getVaultFileContentRaw({
      fileId
    });

    downloadFileFromBuffer(
      await response.raw.arrayBuffer(),
      // v1 always returned a filename; on v3 both it and the title are
      // optional, so the download needs a last-resort name.
      vaultFile.filename ?? vaultFile.title ?? "download",
      vaultFile.mimeType
    );
  });
